import React from 'react';
import { motion } from 'framer-motion';
import { useCountdown } from '../hooks/useCountdown';
import { FlameIcon } from './icons/Icons';
/**
 * Sticky urgency bar with a live countdown timer. Pinned to top of viewport.
 */
export function UrgencyBar() {
  const {
    minutes,
    seconds,
    total
  } = useCountdown(14 * 60 + 59);
  const pad = (n: number) => n.toString().padStart(2, '0');
  return <div className="sticky top-0 z-50 w-full bg-[#7a1e12] text-white shadow-lg" data-id="element-264">
      <div className="mx-auto flex max-w-5xl flex-col items-center justify-center gap-1.5 px-4 py-2.5 text-center sm:flex-row sm:gap-4" data-id="element-265">
        <div className="flex items-center gap-2" data-id="element-266">
          <span className="animate-flicker text-amber-300" data-id="element-267">
            <FlameIcon className="h-5 w-5" strokeWidth={2.2} data-id="element-268" />
          </span>
          <span className="text-[11px] font-bold uppercase tracking-[0.18em] text-amber-200 sm:text-xs" data-id="element-269">
            Barra de Urgencia
          </span>
        </div>
        <p className="text-xs leading-tight text-amber-50 sm:text-sm" data-id="element-270">
          <span className="font-semibold" data-id="element-271">ATENCIÓN:</span> la oferta de{' '}
          <span className="font-bold text-white" data-id="element-272">$10.99</span> expira cuando el
          contador llegue a cero.
        </p>
        <motion.div animate={total <= 60 ? {
        scale: [1, 1.06, 1]
      } : {}} transition={{
        duration: 1,
        repeat: Infinity
      }} className="flex items-center gap-1 rounded-lg bg-black/30 px-3 py-1 font-display text-lg font-extrabold tabular-nums tracking-widest sm:text-xl" data-id="element-273">
          <span data-id="element-274">{pad(minutes)}</span>
          <span className="animate-pulse text-amber-300" data-id="element-275">:</span>
          <span data-id="element-276">{pad(seconds)}</span>
        </motion.div>
      </div>
    </div>;
}